import { NgModule } from "@angular/core";
import { DateRangePickerComponent } from "./date-range-picker/date-range-picker.component";
import { CoreCommonModule } from "../../../@core/common.module";
import { DatePickerComponent } from "./date-picker/date-picker.component";
import {
  NgbAlertModule,
  NgbCollapseModule,
  NgbNavModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { GenericIconComponent } from "./generic-icon/generic-icon.component";
import { NgxBootstrapIconsModule } from "ngx-bootstrap-icons";
import { TelInputComponent } from "./tel-input/tel-input.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { EnumCheckboxSelectorComponent } from "./enum-checkbox-selector/enum-checkbox-selector.component";
import { ListHeaderCellComponent } from "./list-header-cell/list-header-cell.component";
import { NumberRangeComponent } from "./number-range/number-range.component";
import { ModalButtonsComponent } from "./modal-buttons/modal-buttons.component";
import { FilterInputComponent } from "./filter-input/filter-input.component";
import { NgSelectAllHeaderComponent } from "./ng-select-all-header/ng-select-all-header.component";
import { TabComponent } from "./tab/tab.component";
import { LoveItAlertComponent } from "./love-it-alert/love-it-alert.component";
import { DisplayBooleanComponent } from "./display-boolean/display-boolean.component";
import { SelectBooleanComponent } from "./select-boolean/select-boolean.component";
import { NumberPickerComponent } from "./number-picker/number-picker.component";
import { FileUploadModule } from "ng2-file-upload";
import { CustomSortComponent } from "./custom-sort/custom-sort.component";
import { FlatpickrModule } from "angularx-flatpickr";
import { NgOptimizedImage } from "@angular/common";
import { ModalHeaderComponent } from "./modal-header/modal-header.component";
import { NgxMaskDirective } from "ngx-mask";
import { EnumRadioSelectorComponent } from "./enum-radio-selector/enum-radio-selector.component";
import { DirectivesModule } from "../directives/directives.module";
import { OptimisticLockingModalComponent } from "./optimistic-locking-modal/optimistic-locking-modal.component";
import { NgxIntlTelInputModule } from "../../ngx-intl-tel-input/ngx-intl-tel-input.module";

@NgModule({
  declarations: [
    DateRangePickerComponent,
    DatePickerComponent,
    GenericIconComponent,
    TelInputComponent,
    EnumCheckboxSelectorComponent,
    ListHeaderCellComponent,
    NumberRangeComponent,
    ModalButtonsComponent,
    FilterInputComponent,
    NgSelectAllHeaderComponent,
    TabComponent,
    LoveItAlertComponent,
    DisplayBooleanComponent,
    SelectBooleanComponent,
    NumberPickerComponent,
    CustomSortComponent,
    ModalHeaderComponent,
    EnumRadioSelectorComponent,
    OptimisticLockingModalComponent,
  ],
  imports: [
    CoreCommonModule,
    FlatpickrModule.forRoot(),
    NgbPopoverModule,
    NgxIntlTelInputModule,
    NgxBootstrapIconsModule,
    NgSelectModule,
    NgbAlertModule,
    NgbCollapseModule,
    NgbTooltipModule,
    FileUploadModule,
    NgbNavModule,
    NgOptimizedImage,
    NgxMaskDirective,
    DirectivesModule,
  ],
  exports: [
    DateRangePickerComponent,
    DatePickerComponent,
    GenericIconComponent,
    TelInputComponent,
    EnumCheckboxSelectorComponent,
    ListHeaderCellComponent,
    NumberRangeComponent,
    ModalButtonsComponent,
    FilterInputComponent,
    NgSelectAllHeaderComponent,
    TabComponent,
    LoveItAlertComponent,
    DisplayBooleanComponent,
    SelectBooleanComponent,
    NumberPickerComponent,
    CustomSortComponent,
    ModalHeaderComponent,
    EnumRadioSelectorComponent,
    OptimisticLockingModalComponent,
  ],
})
export class ComponentsModule {}
